export enum PaymentLocation {
    CHECKOUT = 'CHECKOUT',
    PRODUCT_DETAIL = 'PRODUCT_DETAIL',
}
